<template>
  <div class="pb-12">
    <v-img :src="require('@/assets/Services-Air-CROP.png')" />
    <div style="max-width: 1000px;" class="mx-auto px-4 py-12 divider-bottom">
      We offer custom tailored solutions for a wide variety of cargo. Fast,
      flexible and highly competitive, our air freight service offers door to
      door delivery, anywhere in the world, regardless of your sector of
      activity. Vancouver Global Shipping provides a turnkey service for your
      international air transport needs. Specializing in forwarding your freight
      to any major international airport, regardless of its origin, means we’ll
      get whatever you’re importing or exporting in the air and handled with
      optimal care. We provide a comprehensive customs service that ensures your
      air freight is accompanied by all necessary documentation for the
      countries of origin and destination while working with the world’s leading
      commercial freight airlines to ensure that your long-distance freight is
      delivered on-time on a consistent basis Whether domestic or international,
      we have an air freight solution for your unique shipping needs.
    </div>

    <div class="primary--text text-center pt-12 px-4">
      COMMERCIAL FREIGHT ONLY ** NO PARCEL SIZE SHIPMENTS-( SINGLE BOXES UNDER
      50 LBS ) WE DO NOT ACCEPT SMALL <br />PERSONAL SHIPMENTS of CLOTHING, FOOD
      OR LOW VALUE ITEMS
    </div>
    <Form class="mx-auto mt-12" />
  </div>
</template>

<script>
import Form from './Form'

export default {
  components: {
    Form,
  },
  computed: {
    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '600px'
        case 'sm': return '600px'
        case 'md': return '600px'
        case 'lg': return '600px'
        case 'xl': return '600px'
        default: return '600px'
      }
    },
  },
}
</script>

<style scoped>
.bottom-border {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
</style>